import { action, atom } from '@reatom/framework'
import { useAction } from '@reatom/npm-react'
import { nanoid } from 'nanoid'

import type { SnackbarProps } from './snackbar'

export interface SnackbarState {
  options: SnackbarOptions
  id: string
}
type SnackbarsState = Array<SnackbarState>

export const snackbarsStateAtom = atom<SnackbarsState>([], 'snackbarsStateAtom')

type SnackbarComponentOptions =
  | {
      text: string
      intent?: SnackbarProps['intent']
      description?: SnackbarProps['description']
      element?: undefined
    }
  | {
      element: React.ReactElement<{ onClose?: () => void }>
    }

export type SnackbarOptions = {
  /**
   * How long the snackbar should be visible
   */
  delay?: number | 'permanent'
  onClose?: () => void
} & SnackbarComponentOptions

export const showSnackbarAction = action((ctx, opts: SnackbarOptions) => {
  const options = { ...opts }
  const { onClose, delay } = opts
  if (onClose || delay === 'permanent') {
    options.onClose = () => {
      snackbarsStateAtom(ctx, (state) =>
        state.filter((it) => it.id !== entry.id),
      )
      onClose?.()
    }
  }
  const entry: SnackbarState = {
    options,
    id: nanoid(),
  }

  if (opts.delay !== 'permanent') {
    setTimeout(() => {
      snackbarsStateAtom(ctx, (state) =>
        state.filter((it) => it.id !== entry.id),
      )
      onClose?.()
    }, opts.delay ?? 5000)
  }

  snackbarsStateAtom(ctx, (st) => [...st, entry])
}, 'showSnackbarAction')

export const useSnackbar = () => {
  const showSnackbar = useAction(showSnackbarAction)

  return {
    showSnackbar,
  }
}
